import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PublicRoutesLayout from "./components/shared/publicRoutesLayout";
import DashboardLayout from "./components/shared/dashboardLayout";
import WithoutPrivateLayout from "./components/shared/withoutSidebarLayout";
import Dashboard from "./components/pages/dashboard/dashboard";
import Courses from "./components/pages/courses/courses";
import MicroCourses from "./components/pages/microCourses/microCourses.js";
import CaseStduies from "./components/pages/caseStudies/caseStudies.js";
import Templates from "./components/pages/templates/templates.js";
import CreateCourses from "./components/pages/courses/createCourse";
import CreateCaseStudies from "./components/pages/caseStudies/createCaseStudies";
import CourseLayout from "./components/shared/courseLayout";
import CourseDetails from "./components/pages/courseDetails/courseDetails";
import CourseContent from "./components/pages/courseContent/courseContent";
import Login from "./components/login/login";
import CreateTemplate from "./components/pages/templates/createTemplate.js";
import EditTemplate from "./components/pages/templates/editTemplate.js";
import EditCaseStudies from "./components/pages/caseStudies/editCaseStudies.js";
import CreateMicroModule from "./components/pages/microCourses/createMicroModule.js";
import MicroModuleLayout from "./components/shared/microModuleLayout.js";
import MicroCourseLayout from "./components/shared/microCourseLayout.js";


export default function AppRoutes() {
    return (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={<PublicRoutesLayout />}
                >  <Route path='/' element={<Login />}></Route>
                </Route>

                <Route
                    path="/"
                    element={<DashboardLayout />}
                >
                    <Route path='/' element={<Courses />}></Route>
                    <Route path='/courses' element={<Courses />}></Route>
                    <Route path='/micro-modules' element={<MicroCourses />}></Route>
                    <Route path='/case-studies' element={<CaseStduies />}></Route>
                    <Route path='/templates' element={<Templates />}></Route>
                    <Route path='/dashboard' element={<Dashboard />}></Route>
                </Route>

                <Route
                    path="/"
                    element={<WithoutPrivateLayout />}
                >
                    <Route path='/create_course' element={<CreateCourses />}></Route>
                    <Route path='/create-case-studies' element={<CreateCaseStudies />}></Route>
                    <Route path='/edit-case-study/:id' element={<EditCaseStudies />}></Route>
                    <Route path='/create_template' element={<CreateTemplate />}></Route>
                    <Route path='/edit_template/:id' element={<EditTemplate />}></Route>

                </Route>

                <Route
                    path="/"
                    element={<CourseLayout />}
                >
                    <Route path='/course_details' element={<CourseDetails />}></Route>
                    <Route path="/course_content" element={<CourseContent />}></Route>
                 
                    <Route path='/create_micro_module' element={<CreateMicroModule />}></Route>

                </Route>

                <Route
                    path="/"
                    element={<MicroCourseLayout />}
                >
                    <Route path='/micro_course_details' element={<CourseDetails />}></Route>
                    <Route path="/micro_course_content" element={<CourseContent />}></Route>
                </Route>

            </Routes>
        </Router>
    );
}

